import { useState } from "react";
import { Modal, Button, Textarea } from "flowbite-react";
import { useCancelInvoice } from "../hook";
import { useInvoiceModals } from "@/common/states/store/slices/invoiceSlice";
import { useAppStore } from "@/common/states/store";
import ButtonWithLoader from "@/common/components/ui/loading/ButtonLoading";
import { useToastContext } from "@/common/components/ui/toast/toast.context";
import * as yup from "yup";

const reasonSchema = yup
  .string()
  .trim()
  .min(15, "O motivo deve ter pelo menos 15 caracteres")
  .required("O motivo é obrigatório");

export const CancelInvoiceModal = () => {
  const [reason, setReason] = useState("");
  const [error, setError] = useState<string | null>(null);
  const cancelInvoice = useCancelInvoice();
  const { notifySuccess, notifyError } = useToastContext();

  const { cancellationIsOpen, editingInvoice } = useInvoiceModals();
  const {
    invoice: { closeModalInvoice },
  } = useAppStore();

  const handleCancel = async () => {
    try {
      await reasonSchema.validate(reason);
      setError(null);

      // ✅ Verificar se editingInvoice existe e extrair o ID
      if (!editingInvoice) {
        setError("Nota fiscal não encontrada");
        return;
      }

      const invoiceId = editingInvoice._id || editingInvoice.toString();
      if (!invoiceId) {
        setError("ID da nota fiscal não encontrado");
        return;
      }

      await cancelInvoice.mutateAsync({ id: invoiceId, reason });
      notifySuccess("Processando pedido de cancelamento");
      closeModalInvoice(); // Fechar modal após sucesso
    } catch (err) {
      if (err instanceof Error && err.name === "ValidationError") {
        setError(err.message);
        return;
      }
      notifyError((err as Error)?.message || "Erro ao cancelar a nota fiscal");
    }
  };

  return (
    <Modal show={cancellationIsOpen} onClose={closeModalInvoice}>
      <Modal.Header>Cancelar Nota Fiscal</Modal.Header>
      <Modal.Body>
        <p className="mb-3">Informe o motivo do cancelamento:</p>
        <Textarea
          placeholder="Motivo do cancelamento"
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          rows={4}
          color={error ? "failure" : undefined}
          helperText={
            error && <span className="text-red-600 text-sm">{error}</span>
          }
        />
      </Modal.Body>
      <Modal.Footer>
        <Button color="gray" onClick={closeModalInvoice}>
          Fechar
        </Button>
        <ButtonWithLoader
          onClick={handleCancel}
          disabled={cancelInvoice.isPending}
          isLoading={cancelInvoice.isPending}
        >
          {cancelInvoice.isPending ? "Processando..." : "Confirmar"}
        </ButtonWithLoader>
      </Modal.Footer>
    </Modal>
  );
};
